<template>
  <div class="reportListPage">
    <div class="save-title">评估报告</div>
    <div class="search-blank">
      <div class="search-choose">
        <span>起止时间：</span>
        <el-date-picker
          v-model="sttm"
          value-format="yyyy-MM-dd"
          style="width: 220px"
          type="date"
          placeholder="开始时间"
          size="large"
        ></el-date-picker>
        -
        <el-date-picker
          style="width: 220px"
          v-model="edtm"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束时间"
          size="large"
        ></el-date-picker>
        <span style="margin-left: 20px">报告类型：</span>
        <el-select
          v-model="status"
          style="width: 200px; margin-right: 12px"
          placeholder="请选择"
          size="large"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span style="margin-left: 20px">报告名称：</span>
        <el-input
          style="width: 200px"
          v-model="reportName"
          placeholder="请输入报告名称"
          size="large"
        ></el-input>
      </div>
      <div class="query__button">
        <el-button type="primary" @click="filterData">查询</el-button>
        <el-button @click="refresh">重置</el-button>
      </div>
    </div>
    <div class="power-data">监测点安全数据</div>
    <div class="list-table">
      <el-table :data="reportList" align="center">
        <el-table-column
          prop="reportId"
          align="center"
          label="报告id"
        ></el-table-column>

        <el-table-column
          prop="reportName"
          align="center"
          label="报告名称"
        ></el-table-column>
        <el-table-column
          prop="reportType"
          align="center"
          label="报告类型"
        ></el-table-column>
        <el-table-column
          prop="reportTime"
          align="center"
          label="报告生产时间"
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showDialog(scope.row)">
              查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="float: right; margin-right: 10px; margin-top: 10px">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="page"
        :page-size="sizePage"
        layout="total,prev, pager, next, jumper"
        :total="paginationTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
export default {
  name: "stationListPage",
  data() {
    return {
      status: null,
      reportName: "",
      reportList: [],
      options: [
        {
          value: null,
          label: "全部",
        },
        {
          label: "周报告",
          value: 1,
        },
        {
          label: "月报告",
          value: 2,
        },
      ],
      page: 1,
      sizePage: 10,
      paginationTotal: 99999,
      edtm: "",
      sttm: "",
    };
  },
  methods: {
    filterData() {
      this.page = 1;
      this.getRiskList();
    },
    refresh() {
      this.getNowTime();
      this.reportName = "";
      this.status = "";
      this.$nextTick(() => {
        this.getRiskList();
      });
    },
    getRiskList() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/findSafeReportPage";
      param.data = {
        startDate: this.sttm,
        endDate: this.edtm,
        pageNum: this.page,
        showNum: this.sizePage,
        reportName: this.reportName,
        type: this.status,
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.paginationTotal = res.data.totalNum;
          this.reportList = res.data.dataList;
        }
      });
    },

    showDialog(row) {
      this.$router.push({
        // path: "/reportDetail",
        path: "/newReport",
        query: {
          row: JSON.stringify(row),
        },
      });
    },
    // 当前页数
    pageChange(val) {
      this.page = val;
      this.getRiskList();
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time = year + "-" + month + "-" + date;

      var yesnow = new Date();
      yesnow.setTime(yesnow.getTime() - 30 * 24 * 60 * 60 * 1000);
      var yesyear = yesnow.getFullYear(); //得到年份
      var yesmonth = yesnow.getMonth(); //得到月份
      var yesdate = yesnow.getDate(); //得到日期

      var yeshour = yesnow.getHours(); //得到小时
      var yesminu = yesnow.getMinutes(); //得到分钟
      var yessec = yesnow.getSeconds(); //得到秒
      var yesMS = yesnow.getMilliseconds(); //获取毫秒
      yesmonth = yesmonth + 1;
      if (yesmonth < 10) yesmonth = "0" + yesmonth;
      if (yesdate < 10) yesdate = "0" + yesdate;
      if (yeshour < 10) yeshour = "0" + yeshour;
      if (yesminu < 10) yesminu = "0" + yesminu;
      if (yessec < 10) yessec = "0" + yessec;
      if (yesMS < 100) yesMS = "0" + yesMS;
      var yestime = "";
      yestime = yesyear + "-" + yesmonth + "-" + yesdate;
      this.sttm = yestime;
      this.edtm = time;
    },
  },
  created() {
    this.getNowTime();
  },
  mounted() {
    this.getRiskList();
  },
  watch: {},
  components: {},
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.reportListPage {
  height: 840px;
  background: #ffffff;
  border-radius: 4px;
}
.save-title {
  padding-left: 36px;
  height: 60px;
  line-height: 60px;
  color: #252b3c;
  font-size: 16px;

  border: 1px solid #f1f0f0;
}
.search-btn {
  width: 56px;
  height: 28px;
  background: #2a62ff;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 28px;
  display: inline-block;
  margin: 0 12px;
  cursor: pointer;
}
.search-blank {
  padding: 36px 36px 0 36px;
  display: flex;
  justify-content: space-between;
}
.restart-btn {
  width: 56px;
  height: 28px;
  background: #fff;
  border-radius: 4px;
  color: #2a62ff;
  text-align: center;
  line-height: 28px;
  display: inline-block;
  border: 1px solid #2a62ff;
  cursor: pointer;
}
.power-data {
  margin-top: 40px;
  color: #252b3c;
  font-size: 14px;
  padding-left: 36px;
}
.list-table {
  padding: 36px;
  height: 600px;
}
</style>
<!--<style>-->
<!--#app .stationDetailPage .risk-history .el-pagination .el-pager li.active{-->
<!--  color: #fff;-->
<!--}-->
<!--</style>-->
<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
